import { render } from "./AnalyticsNotesYearly.vue?vue&type=template&id=41d2cfa2&ts=true"
import script from "./AnalyticsNotesYearly.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesYearly.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__